import { ICountryMask } from "../country/country-masks.model";
import { CountryRulesV2 } from "../country/country-rules-v2.interface";
import { IDealerByLocation } from "../dealer/dealer-by-location.model";
import { IFeatureToggle } from "../feature-toggle/feature-toggle.interface";
import { IRecall } from "../recall/recall.interface";
import { IUserFromBFF } from "../user/user-from-bff.interface";
import { IVehicleDetailsBFF } from "../user/vehicle-from-users.interface";

export interface IInitialData {
  featureToggles: Partial<IFeatureToggle[]>;
  customer: Partial<IUserFromBFF>;
  rules: Partial<CountryRulesV2>;
  masks: Partial<ICountryMask>;
  dealer: Partial<IDealerByLocation>;
  vehicleDetails: Partial<IVehicleDetailsBFF>; //TODO: pedir para unificar os veiculo
  vehicle: Partial<IVehicleDetailsBFF>;
  recalls: Partial<IRecall[]>;
}
